import { Listing } from './../../models/listing.model';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { ListingService } from '@app/core/services/listing.service';
import { take } from 'rxjs/operators';

@Injectable()
export class MyListingResolver implements Resolve<any> {
  constructor(private listingService: ListingService) { }
  resolve(route: ActivatedRouteSnapshot) {
    const userID = JSON.parse(localStorage.getItem('user')).uid;
    return this.listingService.getUserList(userID).pipe(take(1));
  }
}
